import * as React from "react";

import style from "./style.module.css";
import { observer } from "mobx-react-lite";
import { Filter } from "../../store";

interface FilterItemProps {
  filter: Filter;
  index: number;
  onClick: (index: number) => void;
}

const FilterItem = observer((props: FilterItemProps) => {
  const { filter, index, onClick } = props;

  return (
    <div className={style.filter} onClick={() => onClick(index)}>
      {filter.toString()}
    </div>
  );
});

interface FilterListProps {
  filters: Filter[];
  onRemoveFilter: (index: number) => void;
}

export const FilterList = observer((props: FilterListProps) => {
  const { filters, onRemoveFilter } = props;

  const onItemClick = (index: number) => {
    onRemoveFilter(index);
  };

  return filters.map((f, i) => (
    <FilterItem filter={f} onClick={onItemClick} index={i} key={i} />
  ));
});
